/* Copyright (c) 2023 Xperi. All Rights Reserved. */

/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum AppState {
    BACKGROUND = 'background',
    FOREGROUND = 'foreground',
}
